<template>
  <div>
    <b-row>
      <b-col
        sm="12"
        md="9">
        <j-title-header :options="titleEmploymentData"/>
        <b-row>
          <b-col
            sm="12"
            md="12">
            <b-form-group>
              <label> Employee Code </label>
              <j-input
                v-model="data_employee.code"
                :max-length="50"
                placeholder="Employee Code"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            md="6">
            <b-form-group
              :class="{'error-input' : $v.selected_employment_type.$error}">
              <label> Employment Type </label>
              <j-single-select
                v-model="selected_employment_type"
                :options="list_type_employee"
                label="name"
                placeholder="Select Employment Type"/>
            </b-form-group>
          </b-col>
          <b-col
            v-if="isHaveSub"
            sm="12"
            md="6">
            <b-form-group
              :class="{'error-input' : $v.selected_employment_subtype.$error}">
              <label> Employment Sub Type </label>
              <j-single-select
                v-model="selected_employment_subtype"
                :options="list_subtype_employee"
                label="name"
                placeholder="Select Employment Sub Type"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          v-if="data_employee.employment_type === 'CONTRACT'">
          <b-col md="6"/>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_employee.contract_type.$error}">
              <label>Contract Type*</label>
              <j-single-select
                v-model="data_employee.contract_type"
                :options="contract_type_option"
                label="name"
                placeholder="Select Contract Type"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          v-if="data_employee.employment_type === 'CONTRACT'">
          <b-col md="6">
            <b-form-group>
              <label>Contract Start Date</label>
              <j-datepicker
                v-model="data_employee.contract_start_date"
                :disabled-dates="disabled_contract_start_date"
                format="MMM dd, yyyy"
                placeholder="Jan 01, 2020"/>
            </b-form-group>
          </b-col>
          <b-col
            md="6">
            <b-form-group :class="{'error-input' : $v.data_employee.contract_end_date.$error}">
              <label>Contract End Date*</label>
              <j-datepicker
                v-model="$v.data_employee.contract_end_date.$model"
                :disabled-dates="disabled_contract_end_date"
                format="MMM dd, yyyy"
                placeholder="Jan 01, 2020"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            md="6">
            <b-form-group>
              <label> Join Date </label>
              <j-datepicker
                v-model="data_employee.join_date"
                :disabled-dates="disabled_start_dates"
                format="MMM dd, yyyy"
                placeholder="Jan 01, 2020"/>
            </b-form-group>
          </b-col>
          <b-col
            md="6">
            <b-form-group>
              <label> End Date </label>
              <j-datepicker
                v-model="data_employee.end_date"
                :disabled-dates="disabled_end_dates"
                format="MMM dd, yyyy"
                placeholder="Jan 01, 2020"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          v-if="data_employee.employment_type === 'CONTRACT' &&
          data_employee.contract_start_date && data_employee.contract_end_date">
          <b-col md="6"/>
          <b-col
            md="6">
            <b-form-group>
              <label>Contract Time Remaining</label>
              <j-input
                v-model="data_employee.contract_time_remaining"
                disabled/>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            sm="12"
            md="6">
            <b-form-group>
              <label> Employee Status </label>
              <j-single-select
                v-model="data_employee.employee_status"
                :options="status_option"
                label="name"
                value-format="object"
                placeholder="Select Employee Status"/>
            </b-form-group>
          </b-col>
          <b-col
            v-if="data_employee.employee_status"
            sm="12"
            md="6">
            <b-form-group
              v-if="data_employee.employee_status.id === 0"
              :class="{'error-input' : $v.data_employee.nonactive_reason.$error}">
              <label>Nonactive Reason*</label>
              <j-single-select
                v-model="data_employee.nonactive_reason"
                :options="nonactive_reason_option"
                label="name"
                placeholder="Select Nonactive Reason"/>
            </b-form-group>
            <b-form-group
              v-else-if="data_employee.employee_status.id === 1"
              :class="{'error-input' : $v.data_employee.active_reason.$error}">
              <label>Active Reason*</label>
              <j-single-select
                v-model="data_employee.active_reason"
                :options="active_reason_option"
                label="name"
                placeholder="Select Active Reason"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            md="12">
            <b-form-group>
              <label> Departments </label>
              <j-single-select
                v-model="data_employee.teams"
                :options="list_teams"
                label="name"
                value-format="object"
                placeholder="Select Departments"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            md="6">
            <b-form-group>
              <label>Location</label>
              <j-single-select
                v-model="data_employee.company_location"
                :options="list_company"
                placeholder="Select Company"
                label="name"/>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6">
            <b-form-group>
              <label>Country of Office Address</label>
              <j-single-select
                v-model="data_employee.office_country"
                :options="list_country"
                placeholder="Select Country"
                label="name"
                @select="resetOfficeProvince"/>
            </b-form-group>
            <b-form-group v-show="data_employee.office_country">
              <label>Province of Office Address</label>
              <j-single-select
                v-model="data_employee.office_province"
                :options="office_province_options"
                placeholder="Select Province"
                label="name"
                @input="getCity"/>
            </b-form-group>
            <b-form-group
              v-show="show_office_city">
              <label>City of Office Address</label>
              <j-single-select
                v-model="data_employee.office_city"
                :options="office_city_options"
                placeholder="Select City"
                label="name"/>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="12">
            <b-form-group>
              <label> Office Address </label>
              <j-textarea
                v-model="data_employee.office_address"
                placeholder="Office Address"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        sm="12"
        md="3"/>

    </b-row>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
/* eslint-disable no-unneeded-ternary */
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import Constant from '@/utils/constant';

export default {
  components: {

  },
  validations() {
    const validation = {
      data_employee: {
        email: { },
        password: { },
        first_name: { },
        end_date: { },
      },
      data_position: {
        position: {
          required,
        },
      },
      selected_employment_type: { required },
      selected_employment_subtype: { },
    };
    if (this.data_employee.employment_type === 'CONTRACT') {
      validation.data_employee.contract_type = { required };
      validation.data_employee.contract_end_date = { required };
    }
    if (this.data_employee.employee_status && this.data_employee.employee_status.id === 0) {
      validation.data_employee.nonactive_reason = { required };
    } else if (this.data_employee.employee_status && this.data_employee.employee_status.id === 1) {
      validation.data_employee.active_reason = { required };
    }
    if (this.selected_employment_type) {
      const res = this.list_type_employee.find(val => val.id === this.selected_employment_type);
      if (res.subttype.length > 0) {
        validation.selected_employment_subtype = { required };
      }
    }
    return validation;
  },
  data() {
    return {
      jConstant: Constant,
      load_first: false,
      show_office_city: false,
      titleBasicInfo: {
        icon: 'fa-user',
        main_title: 'Identity',
        opt_title: '',
      },
      titleSettings: {
        icon: 'fa-user',
        main_title: 'Settings',
        opt_title: '',
      },
      titleEmploymentData: {
        icon: 'fa-user',
        main_title: 'Employment Data',
        opt_title: '',
      },
      titlePaymentInfo: {
        icon: 'fa-user',
        main_title: 'Payment Info',
        opt_title: '',
      },
      titleAccountProfile: {
        icon: 'fa-user',
        main_title: 'Account Profile',
        opt_title: '',
      },
      titlePosition: {
        icon: 'fa-user',
        main_title: 'Position',
        opt_title: '',
      },
      disabled_start_dates: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(1970, 0, 1),
            to: new Date(1970, 0, 1),
          },
        ],
      },
      disabled_end_dates: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(1970, 0, 1),
            to: new Date(1970, 0, 1),
          },
        ],
      },
      disabled_contract_start_date: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(1970, 0, 1),
            to: new Date(1970, 0, 1),
          },
        ],
      },
      disabled_contract_end_date: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(1970, 0, 1),
            to: new Date(1970, 0, 1),
          },
        ],
      },
      birthday_dates: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(),
            to: new Date(9999, 11, 31),
          },
        ],
      },
      data_employee: {
        id: 0,
        // basic info
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        other_name: '',
        personal_email: '',
        gender: null,
        nationality_type: null,
        id_type: null,
        exp_date: null,
        id_number: null,
        religion: null,
        marital_status: null,
        address: null,
        postal_code: null,
        // settings
        role: [],
        secretary_mode: false,
        secretary_mode_mapping: [],
        employee_id: '',
        // payment info
        bank_name: null,
        bank_account_number: '',
        bank_account_holder_name: '',
        bank_account_branch: '',
        // employment data
        join_date: null,
        employment_type: null,
        contract_type: null,
        contract_time_remaining: null,
        contract_start_date: null,
        contract_end_date: null,
        code: '',
        end_date: null,
        teams: null,
        employee_status: null,
        active_reason: null,
        nonactive_reason: null,
        office_country: null,
        office_province: null,
        office_city: null,
        company_location: null,
        employment_type_id: null,
        employment_subtype_id: null,
        // account profile
        photo: null,
        date_of_birth: '',
        age: 0,
        place_of_birth: '',
        phone_number: '',
        country: null,
        province: null,
        city: null,
        notes: '',
      },
      data_position: {
        id: 0,
        position: null,
        parent_position: '',
        division: [],
      },
      data_positions: [],
      temp_position: null,
      image_default: null,
      show_pass: false,
      user_company_id: 0,
      index_positions: 0,
      labelAddPosition: 'Add Position',
      labelBtnPosition: 'Submit',
      home_city_options: [],
      home_province_options: [],
      office_city_options: [],
      office_province_options: [],
      selected_employment_type: null,
      selected_employment_subtype: null,
      list_subtype_employee: [],
      isHaveSub: false,
      firstLoad: true,
      gender_options: [
        {
          name: 'Male',
          id: 'Male',
        },
        {
          name: 'Female',
          id: 'Female',
        },
      ],
      id_type_options: [
        {
          name: 'KTP / Identity Card',
          text: 'KTP',
          id: Constant.IdTypeKTP,
        },
        {
          name: 'Passport',
          text: 'PASSPORT',
          id: Constant.IdTypePassport,
        },
      ],
      religion_options: [
        {
          name: 'Islam',
          id: 'Islam',
        },
        {
          name: 'Protestant',
          id: 'Christian',
        },
        {
          name: 'Catholic',
          id: 'Catholic',
        },
        {
          name: 'Hindu',
          id: 'Hindu',
        },
        {
          name: 'Buddha',
          id: 'Buddha',
        },
        {
          name: 'Konghucu',
          id: 'Konghucu',
        },
        {
          name: 'Other',
          id: 'Other',
        },
      ],
      marital_options: [
        {
          name: 'Single',
          id: 'Single',
        },
        {
          name: 'Married',
          id: 'Married',
        },
        {
          name: 'Divorced',
          id: 'Divorced',
        },
        {
          name: 'Widowed',
          id: 'Widowed',
        },
      ],
      contract_type_option: [
        {
          id: 'PKWT 1',
          name: 'PKWT 1',
        },
        {
          id: 'PKWT 2',
          name: 'PKWT 2',
        },
      ],
      roles_option: [
        {
          id: 'staff',
          name: 'Staff',
        },
        {
          id: 'sysadmin',
          name: 'SysAdmin',
        },
        {
          id: 'approver',
          name: 'Approver',
        },
        {
          id: 'finance',
          name: 'Finance',
        },
        {
          id: 'management',
          name: 'Management',
        },
        {
          id: 'admin_integration',
          name: 'Admin Integration',
        },
        {
          id: 'admin_payroll',
          name: 'Admin Payroll',
        },
        {
          id: 'hrTimes',
          name: 'HR',
        },
        {
          id: 'picTimes',
          name: 'PIC',
        },
        {
          id: 'hr',
          name: 'HRD',
        },
        {
          id: 'claimer_procurement',
          name: 'Requester Procure',
        },
        {
          id: 'admin_procurement',
          name: 'Admin Procure',
        },
        {
          id: 'management_procurement',
          name: 'Management Procure',
        },
        {
          id: 'approver_procurement',
          name: 'Approver Procure',
        },
        {
          id: 'purchaser_procurement',
          name: 'Purchaser Procure',
        },
        {
          id: 'admin_finance',
          name: 'Admin Finance',
        },
        {
          id: 'finance_procurement',
          name: 'Finance Procure',
        },
        {
          id: 'finance_payroll',
          name: 'Finance Payroll',
        },
        {
          id: 'admin_budget',
          name: 'Admin Budget',
        },
        {
          id: 'budget_custody',
          name: 'Budget Custody',
        },
        {
          id: 'implementor',
          name: 'Implementor',
        },
      ],
      employment_type_option: [
        {
          id: 'PERMANENT',
          name: 'Permanent',
        },
        {
          id: 'PROBATION',
          name: 'Probation',
        },
        {
          id: 'CONTRACT',
          name: 'Contract',
        },
        {
          id: 'OUTSOURCE',
          name: 'Outsource',
        },
        {
          id: 'INTERNSHIP',
          name: 'Internship',
        },
        {
          id: 'CONSULTANT',
          name: 'Consultant',
        },
        {
          id: 'OJT',
          name: 'OJT',
        },
        {
          id: 'PART TIME',
          name: 'Part Time',
        },
        {
          id: 'OTHERS',
          name: 'Others',
        },
      ],
      teams_option: [],
      status_option: [
        {
          id: 1,
          name: 'Active',
        },
        {
          id: 0,
          name: 'Nonactive',
        },
      ],
      active_reason_option: [
        {
          id: 'Paid Leave',
          name: 'Paid Leave',
        },
        {
          id: 'Unpaid Leave',
          name: 'Unpaid Leave',
        },
      ],
      nonactive_reason_option: [
        {
          id: 'Serving Notice Period',
          name: 'Serving Notice Period',
        },
        {
          id: 'Terminated',
          name: 'Terminated',
        },
        {
          id: 'Resigned',
          name: 'Resigned',
        },
        {
          id: 'Retrenched',
          name: 'Retrenched',
        },
        {
          id: 'Contract End',
          name: 'Contract End',
        },
        {
          id: 'To Join',
          name: 'To Join',
        },
      ],
      nationality_options: [
        {
          id: 'Warga Negara Indonesia (WNI)',
          name: 'Warga Negara Indonesia (WNI)',
        },
        {
          id: 'Warga Negara Asing (WNA)',
          name: 'Warga Negara Asing (WNA)',
        },
      ],
    };
  },
  computed: {
    ...mapState('jStoreEmployee', ['list_company', 'list_country', 'list_province', 'list_city', 'list_bank', 'list_teams', 'employee_detail', 'organigram_detail', 'list_type_employee']),

    api() {
      return this.$ls.get('Token', null);
    },
    url_upload() {
      return `${process.env.GATE_URL}file`;
    },
    password_id() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },
  },
  watch: {
    list_type_employee(data) {
      this.data_employee.employment_subtype_id = this.selected_employment_subtype;
      this.list_subtype_employee = [];
      const type = data.find(val => val.id === this.selected_employment_type);
      if (type) {
        if (type.subttype.length > 0) {
          type.subttype.forEach((val) => {
            this.list_subtype_employee.push(val);
          });
          this.isHaveSub = true;
        } else {
          this.isHaveSub = false;
        }
      }
    },
    selected_employment_type(data) {
      this.list_subtype_employee = [];
      if (data) {
        const type = this.list_type_employee.find(val => val.id === data);
        if (type) {
          if (type.subttype.length > 0) {
            type.subttype.forEach((val) => {
              this.list_subtype_employee.push(val);
            });
            this.isHaveSub = true;
          } else {
            this.selected_employment_subtype = null;
            this.data_employee.employment_subtype_id = null;
            this.isHaveSub = false;
          }
          this.data_employee.employment_type_id = data;
        }
      } else {
        this.isHaveSub = false;
        this.selected_employment_type = null;
        this.data_employee.employment_type_id = null;
      }
    },
    selected_employment_subtype(data) {
      if (data) {
        this.data_employee.employment_subtype_id = data;
      }
    },
    employee_detail(newVal) {
      if (newVal.company.employment_type_id !== 0) {
        this.selected_employment_type = newVal.company.employment_type_id;
      } else {
        this.selected_employment_type = null;
      }

      if (newVal.company.employment_subtype_id !== 0) {
        this.selected_employment_subtype = newVal.company.employment_subtype_id;
      } else {
        this.selected_employment_subtype = null;
      }

      const dataRoles = [];
      newVal.role_names.forEach((val) => {
        dataRoles.push({
          id: val,
        });
      });

      const dataMapSec = [];
      newVal.secretary_mode_list_team.forEach((val) => {
        dataMapSec.push({
          id: val,
        });
      });

      const dataBank = [];
      if (newVal.company.bank_account_name && this.list_bank.length > 0) {
        const listBank = this.list_bank.filter(fildat =>
          fildat.name.toLowerCase() === newVal.company.bank_account_name.toLowerCase());
        if (listBank.length > 0) {
          dataBank.push(listBank[0]);
        }
      }

      const employeeForm = {
        id: newVal.id,
        email: newVal.email,
        first_name: newVal.first_name,
        last_name: newVal.last_name,
        personal_email: newVal.personal_email,
        join_date: newVal.company.join_date && newVal.company.join_date !== '0000-00-00' ? newVal.company.join_date : null,
        employment_type_id: newVal.company.employment_type_id ? newVal.company.employment_type_id : null,
        employment_subtype_id: newVal.company.employment_subtype_id ? newVal.company.employment_subtype_id : null,
        contract_type: newVal.company.type_of_contract ? newVal.company.type_of_contract : null,
        contract_time_remaining: newVal.company.contract_time_remaining ? newVal.company.contract_time_remaining : null,
        code: newVal.company.employee_code,
        end_date: newVal.company.resign_date && newVal.company.resign_date !== '0000-00-00' ? newVal.company.resign_date : null,
        teams: newVal.company.group_id !== 0 ? { id: newVal.company.group_id } : null,
        employee_status: { id: newVal.company.employee_status },
        active_reason: newVal.company.active_reason === 0 || newVal.company.active_reason === '' ? null : newVal.company.active_reason,
        nonactive_reason: newVal.company.non_active_reason === '' ? null : newVal.company.non_active_reason,
        role: dataRoles,
        secretary_mode: newVal.secretary_mode_list_team.length > 0 ? true : false,
        secretary_mode_mapping: dataMapSec,
        bank_name: dataBank.length > 0 ? dataBank[0] : null,
        bank_account_number: newVal.company.bank_account_number,
        bank_account_holder_name: newVal.company.bank_account_owner,
        bank_account_branch: newVal.company.bank_account_branch,
        employee_id: newVal.employee_id,
        date_of_birth: newVal.date_of_birth,
        age: newVal.age,
        place_of_birth: newVal.place_of_birth,
        phone_number: newVal.phone_number,
        photo: newVal.photo_url,
        country: newVal.country_id ? { id: newVal.country_id } : null,
        other_name: newVal.other_name ? newVal.other_name : null,
        gender: newVal.gender ? newVal.gender : null,
        id_type: newVal.id_type ? { id: newVal.id_type } : null,
        id_number: newVal.id_number ? newVal.id_number : null,
        religion: newVal.religion ? newVal.religion : null,
        marital_status: newVal.marital_status ? newVal.marital_status : null,
        address: newVal.address ? newVal.address : null,
        postal_code: newVal.postal_code ? newVal.postal_code : null,
        province: newVal.province_id ? newVal.province_id : null,
        city: newVal.city_id ? newVal.city_id : null,
        office_city: newVal.company.office_city_id ? newVal.company.office_city_id : null,
        office_province: newVal.company.office_province_id ? newVal.company.office_province_id : null,
        office_country: newVal.company.office_country_id ? newVal.company.office_country_id : null,
        company_location: newVal.company.location_id ? newVal.company.location_id : null,
        contract_start_date: newVal.company.contract_start_date && newVal.company.contract_start_date !== '0000-00-00' ? newVal.company.contract_start_date : null,
        contract_end_date: newVal.company.contract_end_date && newVal.company.contract_end_date !== '0000-00-00' ? newVal.company.contract_end_date : null,
        office_address: newVal.company.office_address ? newVal.company.office_address : null,
        notes: newVal.about,
        exp_date: newVal.passport_expirity_date && newVal.passport_expirity_date !== '0000-00-00' ? newVal.passport_expirity_date : null,
        nationality_type: newVal.nationality_type ? newVal.nationality_type : null,
      };
      this.data_employee = employeeForm;
      this.image_default = newVal.photo_url;
      this.user_company_id = newVal.user_company_id;
      this.load_first = true;
    },

    organigram_detail(newVal) {
      const list = [...newVal];
      this.data_positions = [];
      list.forEach((val) => {
        this.data_positions.push({
          id: val.organigram.id,
          position_name: val.organigram.name,
          position_code: val.organigram.code,
          description: val.organigram.description,
          divisions: val.organigram.divisions || [],
          fulldata: val.organigram,
        });
      });

      if (newVal.length > 0 && this.firstLoad) {
        this.data_position.position = {
          id: newVal[0].organigram.id,
          label: newVal[0].organigram.name,
          text: newVal[0].organigram.name,
          position_name: newVal[0].organigram.name,
          position_code: newVal[0].organigram.code,
          description: newVal[0].organigram.description,
          divisions: newVal[0].organigram.divisions || [],
          fulldata: newVal[0].organigram,
        };

        this.temp_position = {
          id: newVal[0].organigram.id,
          name: newVal[0].organigram.name,
          code: newVal[0].organigram.code,
          description: newVal[0].organigram.description,
          user_company_id: this.user_company_id,
          organigram_head_id: newVal[0].organigram.organigram_head_id,
          organigram_head_name: newVal[0].organigram.organigram_head_name,
          divisions: newVal[0].organigram.divisions || [],
        };

        this.labelAddPosition = 'Update Position';
        this.labelBtnPosition = 'Update';
      }
    },

    // eslint-disable-next-line
    'data_position.position': function (newData) {
      this.data_position.parent_position = '';
      this.data_position.division = [];
      if (newData.organigram_head_id !== 0) {
        this.data_position.parent_position = newData.organigram_head_name;
      }

      if (newData.divisions.length > 0) {
        const dataDivisions = newData.divisions;
        dataDivisions.forEach((val, index) => {
          dataDivisions[index].label = val.name;
        });
        this.data_position.division = dataDivisions;
      }
    },

    // eslint-disable-next-line
    'data_employee.email': function(val) {
      const data = val.replace(/\s/g, '');
      this.data_employee.email = data;
    },

    // eslint-disable-next-line
    'data_employee.country.id': function(val) {
      if (val !== null && typeof val !== 'undefined') {
        const req = {
          country_id: val,
        };
        this.getListProvince(req)
          .then(() => {
            this.home_province_options = [];
            this.home_province_options.push(...this.list_province);
          });
      }
    },

    // eslint-disable-next-line
    'data_employee.province': function(val) {
      if (val !== null && typeof val !== 'undefined') {
        const req = {
          province_id: val,
        };
        this.getListCity(req)
          .then(() => {
            this.home_city_options = [];
            this.home_city_options.push(...this.list_city);
          });
      }
    },

    // eslint-disable-next-line
    'data_employee.office_country': function(val) {
      if (val !== null && typeof val !== 'undefined') {
        const req = {
          country_id: val,
        };
        this.getListProvince(req)
          .then(() => {
            this.office_province_options = [];
            this.office_province_options.push(...this.list_province);
          });
      }
    },

    // eslint-disable-next-line
    'data_employee.join_date': function(val) {
      if (val) {
        this.disabled_end_dates.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
        ];
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
        ];
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
        ];
      }
      if (val && this.data_employee.end_date) {
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
          {
            from: new Date(this.data_employee.end_date),
            to: new Date(9999, 11, 31),
          },
        ];
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
          {
            from: new Date(this.data_employee.end_date),
            to: new Date(9999, 11, 31),
          },
        ];
      }
    },

    // eslint-disable-next-line
    'data_employee.end_date': function(val) {
      if (val) {
        this.disabled_start_dates.ranges = [
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
      }
      if (val && this.data_employee.join_date) {
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(this.data_employee.join_date),
          },
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(this.data_employee.join_date),
          },
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
      }
    },

    // eslint-disable-next-line
    'data_employee.contract_start_date': function(val) {
      if (val) {
        this.disabled_contract_end_date.ranges = [
          {
            from: new Date(1970, 0, 1),
            to: new Date(val),
          },
        ];
      }
    },

    // eslint-disable-next-line
    'data_employee.contract_end_date': function(val) {
      if (val) {
        this.disabled_contract_start_date.ranges = [
          {
            from: new Date(val),
            to: new Date(9999, 11, 31),
          },
        ];
      }
    },
  },
  created() {
    this.load_first = false;
    const reqData = {
      pagination: {
        limit: 0,
        page: 1,
        column: '',
        ascending: true,
        query: '',
        query_type: 'name',
      },
    };
    this.getListCompany(reqData);
    this.getListCountry();
    // this.getListBankAll(reqData);
    this.getListTeams(reqData);
    this.modeUpdate();
  },
  methods: {
    ...mapActions('jStoreEmployee', ['getListCompany', 'getListCountry', 'getListProvince', 'getListCity', 'getListBankAll', 'getListTeams', 'detailEmployee']),

    modeUpdate() {
      const employeeId = {
        id: Number(this.$route.params.id),
      };

      this.detailEmployee(employeeId);
    },

    resetProvince() {
      this.data_employee.province = null;
    },
    resetCity() {
      this.data_employee.city = null;
    },
    resetOfficeProvince() {
      this.data_employee.office_province = null;
    },
    getCity(val) {
      if (val !== null && typeof val !== 'undefined') {
        this.show_office_city = true;
        const req = {
          province_id: val,
        };
        this.getListCity(req)
          .then(() => {
            this.office_city_options = [];
            this.office_city_options.push(...this.list_city);
          });
      } else {
        this.show_office_city = false;
        this.data_employee.office_city = null;
      }
    },
    getDataImage(data) {
      this.data_employee.photo = data;
    },
    save() {
      this.$v.selected_employment_type.$touch();
      if (!this.$v.selected_employment_type.$error) {
        this.$v.selected_employment_subtype.$touch();
        if (!this.$v.selected_employment_subtype.$error) {
          this.$v.data_employee.$touch();
          if (!this.$v.data_employee.$error) {
            this.$emit('data', this.data_employee);
          } else {
            this.$emit('data', null);
          }
        } else {
          this.$emit('data', null);
        }
      } else {
        this.$emit('data', null);
      }
    },
    onShowModal() {
      this.labelAddPosition = 'Add Position';
      this.labelBtnPosition = 'Submit';
      this.$refs.addPosition.show();
      this.$v.data_position.$reset();
    },
    onClose() {
      this.$refs.addPosition.hide();
      this.data_position.position = null;
      this.data_position.parent_position = null;
      this.data_position.division = null;
    },
    onClickEdit(index) {
      this.index_positions = index;
      this.labelAddPosition = 'Update Position';
      this.labelBtnPosition = 'Update';
      this.$refs.addPosition.show();
      this.data_positions[index].fulldata.label = this.data_positions[index].fulldata.name;
      this.data_position.position = this.data_positions[index].fulldata;
    },
    onClickDelete(index) {
      const dataDivisions = [];
      this.data_positions[index].divisions.forEach((val) => {
        dataDivisions.push(val.id);
      });

      const data = {
        id: this.data_positions[index].id,
        name: this.data_positions[index].position_name,
        code: this.data_positions[index].position_code,
        description: this.data_positions[index].description,
        user_company_id: 0,
        organigram_head_id: this.data_positions[index].fulldata.organigram_head_id,
        organigram_head_name: this.data_positions[index].fulldata.organigram_head_name,
        divisions: dataDivisions,
      };
      const generateData = {
        payload: data,
        user_company_id: this.user_company_id,
      };
      this.updateOrganigram(generateData);
    },
    loadOptionsBank({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'name',
          },
        };
        this.$store.dispatch('jStoreEmployee/getListBank', { reqData, callback });
      }
    },
    loadOptionsPosition({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.$store.dispatch('jStoreEmployee/getListPosition', { reqData, callback, label: (this.filter ? this.filter : 'name') });
      }
    },
    loadOptionsPositionParent({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.$store.dispatch('jStoreEmployee/getListPosition', { reqData, callback, label: (this.filter ? this.filter : 'name') });
      }
    },
    loadOptionsDivision({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
          },
        };
        this.$store.dispatch('jStoreEmployee/getListDivision', { reqData, callback });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-employee/assignment/jAssignmentFormUpdate.vue